<template>
  <a-modal v-model="visible" width="70%">
    <div slot="footer">
      <a-button type="default" @click="() => visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('目录')">
        <a-input v-model="form.folderName" disabled />
      </a-form-model-item>
      <a-form-model-item :label="$t('页面名称')" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item :label="$t('英文名')" prop="nameEn">
        <a-input v-model="form.nameEn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('权限字符')" prop="roleKeys">
        <a-input v-model="form.roleKeys" />
      </a-form-model-item>
      <a-form-model-item :label="$t('图标')" prop="icon">
        <a-upload accept="image/*" :customRequest="file => handleUploadLogo(file, 'icon')" listType="picture-card" :fileList="logoList" @change="file => handleLogoChange(file, 'logoList')" @preview="handleLogoPreview">
          <a-button type="primary" v-if="logoList.length == 0">{{ $t('选择图标') }}</a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('页面加载方式')" prop="loadType">
        <a-select v-model="form.loadType" :options="PageLoadTypeOptions" @change="handleLoadTypeChanged" />
      </a-form-model-item>
      <a-form-model-item :label="$t('外链地址')" prop="loadPath" v-if="form.loadType === '0'">
        <a-input v-model="form.loadPath" />
      </a-form-model-item>
      <a-form-model-item :label="$t('页面文件')" prop="loadPath" v-if="form.loadType === '1'">
        <a-upload accept=".txt,.json" :customRequest="file => handleUploadLogo(file, 'loadPath')" :fileList="loadFileList" @change="file => handleLogoChange(file, 'loadFileList')">
          <a-button type="primary" v-if="loadFileList.length == 0">{{ $t('选择文件') }}</a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort">
        <a-input-number :min="1" :precision="0" v-model="form.sort" />
      </a-form-model-item>
    </a-form-model>
    <a-modal v-model="previewVisible" :footer="null">
      <img style="width: 100%" :src="logoUrl" />
    </a-modal>
  </a-modal>
</template>
<script>
import { savePage } from '@/api/app/page'
import { uploadFile, getDownloadUrl } from '@/api/file/file'
import { PageLoadTypeOptions } from '@/constants/AppConstants'

export default {
  data() {
    return {
      PageLoadTypeOptions,
      visible: false,
      loading: false,
      form: {},
      previewVisible: false,
      logoList: [],
      loadFileList: [],
    }
  },
  computed: {
    logoUrl() {
      const logoList = this.logoList.filter(e => e.status === 'done')
      if (logoList.length === 0) {
        return null
      }
      const logo = logoList[0]
      const fileId = logo.response.id
      return getDownloadUrl(fileId)
    },
    rules() {
      return {
        name: [
          { required: true, message: this.$t('请输入') }
        ]
      }
    }
  },
  methods: {
    show(data) {
      this.form = { loadType: '2', ...data, folderName: data.folderName || this.$t('无') }
      this.logoList = this.form.icon ? [{
        uid: this.form.icon,
        name: 'logo',
        status: 'done',
        response: { id: this.form.icon },
        url: getDownloadUrl(this.form.icon)
      }] : []
      this.loadFileList = (this.form.loadPath && this.form.loadType === '1') ? [{
        uid: this.form.loadPath,
        name: this.$t('页面文件'),
        status: 'done',
        response: { id: this.form.loadPath },
        url: getDownloadUrl(this.form.loadPath)
      }] : []
      this.visible = true
    },
    handleLoadTypeChanged() {
      this.form.loadPath = null
      this.loadFileList = []
    },
    handleUploadLogo(file, fieldKey) {
      file.onProgress()
      uploadFile(file.file).then(res => {
        if (res.code === 0) {
          file.onSuccess(res.data)
          this.form[fieldKey] = res.data.id
        } else {
          file.onError(res.message)
          this.$message.error(res.message)
        }
      }).catch(e => {
        file.onError(e)
      })
    },
    handleLogoChange(data, fieldKey) {
      const fileList = data.fileList
      fileList.forEach(f => {
        if (f.status === 'done') {
          f.url = getDownloadUrl(f.response.id)
        }
      })
      this[fieldKey] = fileList
    },
    handleLogoPreview() {
      this.previewVisible = true
    },
    handleCommit() {
      this.$refs.form.validate((success, fields) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          id: this.form.id,
          name: this.form.name,
          nameEn: this.form.nameEn,
          roleKeys: this.form.roleKeys,
          folderId: this.form.folderId,
          ruleType: '0',
          sort: this.form.sort,
          icon: this.form.icon,
          loadType: this.form.loadType,
          loadPath: this.form.loadPath
        }
        savePage(commitData).then(res => {
          if (res.code === 0) {
            this.$emit('ok')
            this.$message.success(this.$t('保存成功'))
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>